const NUMERIC_PATTERN = /^\d+(\.\d+)?$/;
function parseFontSize(size) {
  if (typeof size === "string" && !NUMERIC_PATTERN.test(size)) {
    return size;
  }
  return `${size}px`;
}

export { parseFontSize };
//# sourceMappingURL=parseFontSize.mjs.map
